export type SubscriptionProvider = 'mercadopago' | 'apple' | 'google' | null;

export type PaidTier = 'gratis' | 'emprende' | 'crece' | 'other';

export function normalizeSubscriptionProvider(
  v: string | null | undefined,
): SubscriptionProvider {
  if (v == null || v === '') return null;
  const x = String(v).trim().toLowerCase();
  if (x === 'mercadopago') return 'mercadopago';
  if (x === 'apple') return 'apple';
  if (x === 'google') return 'google';
  return null;
}

export const PLAN_TAGLINES: Record<'emprende' | 'crece', string> = {
  emprende: 'Más ventas, pedidos y turnos desde un solo local.',
  crece: 'Sucursales y usuarios sin límite, auditoría y análisis avanzado.',
};

/** Bullets cortos para cards de oferta (alineado al proto Opción A). */
export const PLAN_OFFER_HIGHLIGHTS: Record<'gratis' | 'emprende' | 'crece', string[]> = {
  gratis: ['1 sucursal', '1 usuario', 'productos sin límite'],
  emprende: ['1 sucursal', '1 usuario', 'más capacidad mensual'],
  crece: ['Todo lo de Gratis + equipo, multi-sucursal y sin topes'],
};

export const CUSTOM_PLAN_HIGHLIGHTS = [
  'Más sucursales, usuarios o productos que Crece',
  'Límites y funciones según cómo operás',
];

export function resolvePaidTier(planCode: string | undefined | null): PaidTier {
  const p = (planCode ?? '').trim().toLowerCase();
  if (p === 'emprende') return 'emprende';
  if (p === 'crece') return 'crece';
  // Compatibilidad legacy
  if (p === 'completo' || p === 'esencial') return 'crece';
  if (p === 'gratis' || p === '') return 'gratis';
  return 'other';
}

/**
 * Plan de pago facturado (suscripción real).
 * Sin `subscription_provider` no hay cobro activo: aunque el plan efectivo sea
 * Crece por grant, para la UI de Billing se trata como `gratis`
 * (así se muestran las cards de suscripción).
 */
export function resolveSubscribedPaidTier(
  entitlements: { plan_code?: string; active_plan_grant?: unknown; subscription_provider?: unknown } | null | undefined,
): PaidTier {
  if (!entitlements) return 'gratis';
  const hasPaidProvider =
    entitlements.subscription_provider != null &&
    String(entitlements.subscription_provider).trim() !== '' &&
    String(entitlements.subscription_provider).toLowerCase() !== 'null';
  if (!hasPaidProvider) {
    return 'gratis';
  }
  return resolvePaidTier(entitlements.plan_code);
}
